module.exports = __webpack_public_path__ + "img/selo-gestao.2413049b.jpeg";